module.exports = __webpack_public_path__ + "static/img/shadowLogo.1d72577e.png";